module.exports = __webpack_public_path__ + "static/media/id-number-2012.89b525e3.jpg";